/* eslint-disable import/prefer-default-export */
import ky from 'ky';
import config from '../../config';
import { CustomError } from '../error/error.util';

/**
 * API "client" for the neural network backend
 *
 * @example
 *  const upload = await network.post('analyses', { body: ... });
 */
export const network = ky.extend({
  prefixUrl: config.network.backendUrl,
  headers: { Authorization: `Bearer ${config.network.apiKey}` },
});

/**
 * Upload a model (STEP) file to the neural network to trigger an analysis and
 * return the PID.
 *
 * @param data The data containing the `file` to upload as well an `id` to construct the `callbackUrl` with
 *
 * @example await upload(data);
 */
export const analyzeModel$ = async ({ file, id }: { file: File; id: string }): Promise<string> => {
  try {
    const formData = new FormData();
    formData.append('callbackUrl', `${config.network.callbackUrl}/${id}`);
    formData.append('file', file);

    const { data } = await network.post('analyses', { body: formData }).json();

    return data.pid;
  } catch (error) {
    switch (error.response?.status) {
      case 401:
        throw new CustomError({
          ...CustomError.errors.network.Auth,
          originalError: error,
        });

      case 422:
        throw new CustomError({
          ...CustomError.errors.network.DataInvalidError,
          originalError: error,
        });

      // 406, 500, 503 & everything else
      default:
        throw new CustomError({
          ...CustomError.errors.network.General,
          originalError: error,
        });
    }
  }
};
